module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/performance/performance-product-statistics/performance-product-statistics.component.scss
// module id = ./src/app/routes/performance/performance-product-statistics/performance-product-statistics.component.scss
// module chunks = 9